import { observer } from "mobx-react";
import React from "react";
import { useState, useMemo } from "react";
import { useDrag } from "react-dnd";

interface DraggableEventProps {
  area: "Outer" | "Inner";
  currentDate: any;
  data: any;
  children: (props: {
    onResizingChange: (isResizing: boolean) => void;
  }) => React.ReactNode;
  style: React.CSSProperties;
}

const DraggableEvent: React.FC<DraggableEventProps> = ({
  area,
  currentDate,
  data,
  children,
  style,
}) => {
  const [isResizing, setIsResizing] = useState(false);

  const dragSpec = useMemo(
    () => ({
      type: "EVENT",
      item: { data, currentDate, area },
      canDrag: !isResizing,
      collect: (monitor: any) => ({
        isDragging: monitor.isDragging(),
      }),
    }),
    [isResizing, data, currentDate, area]
  );

  const [{ isDragging }, drag] = useDrag(dragSpec);

  return (
    <div
      ref={!isResizing ? drag : null}
      className={`event-box draggable-event ${isDragging ? "dragging" : ""}`}
      style={style}
    >
      {children({ onResizingChange: setIsResizing })}
    </div>
  );
};

// Use React.memo with shallow comparison for performance
export default observer(DraggableEvent);
